import React, { useEffect } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import CircularProgress from "@material-ui/core/CircularProgress";
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../sessionStorage';

export default function EsignReturn(props) {
  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;

  useEffect(() => {
    Redirect();

    setTimeout(Redirect, 500); //redirect after .5 second

    setTimeout(Redirect, 1000); //redirect after 1 second

    setTimeout(Redirect, 5000); //failsafe, after 5 seconds
  }, []);

  const Redirect = () => {
    var url = window.location.href;
    url = url.replace(/\/Esignreturn/gi, '/status');

    if(url.includes('event')){
      const eventName = new URLSearchParams(window.location.search).get('event');
      const caseId = new URLSearchParams(window.location.search).get('EntityID');
      if(eventName === "SignComplete"){
        fetch(`${covrServicesUrl}/api/ESign/UpdateSignedDate?caseID=${parseInt(caseId)}`,
          {
            method: 'GET',
            headers: {
              'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
            }
          })
      }
    }
    window.top.location.href = url;
  };

  return (
    <Container>
      <Row>
        <Col lg={8}>
          <div>
            <br />
            <br />
            <CircularProgress />
            <br />
            <br />
            Please Wait While Your Application Is Being Processed...
            <br />
            <br />
            If this page does not redirect within 15 seconds, please{' '}
            <a id="uiRedirect" onClick={Redirect}>
              click here
            </a>
            <br />
            <br />
          </div>
        </Col>
      </Row>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/EsignReturn.js